module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/tick dim-9c841242.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/tick dim.svg
// module id = ./app/web/src/assets/tick dim.svg
// module chunks = 0